<template>
  <vs-sidebar
    click-not-close
    position-right
    parent="body"
    default-index="1"
    color="primary"
    class="add-new-data-sidebar items-no-padding"
    spacer
    v-model="isSidebarActiveLocal"
  >
    <div class="mt-6 flex items-center justify-between px-6">
      <h4>{{ type == 1 ? $t("AddSubCustomer") :  $t("EditSubCustomer") }}</h4>
      <feather-icon
        icon="XIcon"
        @click.stop="isSidebarActiveLocal = false"
        class="cursor-pointer"
      ></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>
    <div v-if="!loadingData">
      <component
        :is="scrollbarTag"
        class="scroll-area--data-list-add-new"
        :settings="settings"
        :key="$vs.rtl"
      >
        <vs-alert :active="errMsg" color="danger" icon="new_releases">
          <span>{{ errMsgContent }}</span>
        </vs-alert>
        <!-- ADD -->
        <div class="p-6 pt-0" v-if="type == 1">
          <!-- NAME -->
          <label class="font-bold">
            {{ $t("name") }} :
            <span style="font-size: 1.2rem" class="text-danger font-bold"
              >*</span
            ></label
          >
          <vs-input
            v-model="dataAddSubUser.name"
            v-validate="'required'"
            class="mt-5 w-full font-bold"
            name="name"
            maxlength="100"
            minlength="3"
            @input="nameErrorShow"
          />
          <span v-if="nameError" class="text-danger font-bold text-sm"
            ><small> الاسم يجب أن يكون 3 أحرف على اﻷقل</small></span
          >


          <div class="first-input mt-3">
          <!-- number1 -->
          <label class="font-bold">
            {{ $t("number1") }} :
            <span style="font-size: 1.2rem" class="text-danger font-bold"
              >*</span
            ></label
          >
     
          <vue-tel-input
          v-model="dataAddSubUser.follow_up_phone"
            mode="international"
            :inputOptions="internationalInputOptions"
            :defaultCountry="'LY'"
            :validCharactersOnly="true"
            @validate="phoneObject($event, 'follow_up_phone')"
              name="number"
            v-validate="'required'"
            @input="clearErrorMessage('follow_up_phone')"
            dir="ltr"
          ></vue-tel-input>

          <span style="font-size: 0.7rem" class="text-danger err-msg"
          >{{ errors.first("number")
          }}<span v-if="!this.validationsPhone.follow_up_phone && dataAddSubUser.follow_up_phone.trim().length != 15"
            >يجب ادخال رقم هاتف صحيح</span
          >
        </span>

        </div>
        </div>
        <!-- EDIT -->
        <div class="p-6" v-else-if="type == 2">
          <!-- NAME -->

        <div class="p-6 pt-0" v-if="type == 2">

            <!-- NAME -->
            <label class="font-bold">
            {{ $t("name") }} :
            <span style="font-size: 1.2rem" class="text-danger font-bold"
              >*</span
            ></label
          >
          <vs-input
            v-model="dataAddSubUser.name"
            v-validate="'required'"
            class="mt-5 w-full font-bold"
            name="name"
            maxlength="100"
            minlength="3"
            @input="nameErrorShow"
          />
          <span v-if="nameError" class="text-danger font-bold text-sm"
            ><small> الاسم يجب أن يكون 3 أحرف على اﻷقل</small></span
          >


          <div class="first-input mt-3">
          <!-- number1 -->
          <label class="font-bold">
            {{ $t("number1") }} :
            <span style="font-size: 1.2rem" class="text-danger font-bold"
              >*</span
            ></label
          >


          <vue-tel-input
            v-model="dataAddSubUser.follow_up_phone"
            mode="international"
            :inputOptions="internationalInputOptions"
            :defaultCountry="'LY'"
            :validCharactersOnly="true"
            @validate="phoneObject($event, 'follow_up_phone')"
              name="number"
            v-validate="'required'"
            @input="clearErrorMessage(dataAddSubUser.follow_up_phone)"
            dir="ltr"
          ></vue-tel-input>


          <span style="font-size: 0.7rem" class="text-danger err-msg">
          <span v-if="!this.validationsPhone.follow_up_phone"
            >يجب ادخال رقم هاتف صحيح</span
          >
        </span>


        </div> 

        <p v-if="errMsg">{{ errMsgContent }}</p>
        </div>
        </div>
      </component>

      <div class="flex flex-wrap items-center p-6 justify-end" slot="footer">
        <button
          v-if="!loading"
          class="mr-6 send-order"
          @click="submitData"
          style="font-family: Cairo"
        >
          {{ $t("save") }}
        </button>
        <button v-else class="mr-6 send-order">
          <SpinnerColor2 />
        </button>
      </div>
    </div>
    <div v-else class="flex items-center justify-center h-full">
      <spinner-color2 />
    </div>
    <ModalDeleteVue
      v-if="deleteModal"
      @closeModal="closeDeleteModal()"
      @actionDelete="removeToken()"
      :loadingAction="loadingRemoveToken"
      description="هل انت متأكد من حذف معرف الجهاز"
    />
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import SpinnerColor2 from "./SpinnerColor2.vue";
import notifyState from "@/mixins/notifyState";
import ModalDeleteVue from "@/layouts/components/ModalDelete.vue";
import SelectInputVue from "@/layouts/components/SelectInput.vue";
import Axios from "axios";
import validationPhone from "@/mixins/validationPhone.js";

export default {
  name: "add-sub-user-data",
  mixins: [notifyState,validationPhone],
  props: {
    isSidebarActive: {
      type: Boolean,
    },
    type: {
      type: Number,
    },
    id: {
      type: Number,
    },
    editData: {
      default: "",
    },
  },
  components: {
    VuePerfectScrollbar,
    SpinnerColor2,
    ModalDeleteVue,
    SelectInputVue,
  },
  data() {
    return {
      loadingData: false,
      nameError: false,
      errMsgContent: "",
      // phone1ErrorMessage,
      dataAddSubUser: {
        name: "",
        follow_up_phone: "",
      },
      // dataEditUser: {},
      loading: false,
      loadingRemoveToken: false,
      errMsg: false,
      settings: {
        // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: 0.6,
      },
      deleteModal: false,
    };
  },
  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closeSidebar");
        }
      },
    },
    scrollbarTag() {
      return this.$store.getters.scrollbarTag;
    },
    checkConfirmationPassword() {
      if (this.password) this.requiredConfirmation = true;
      else this.requiredConfirmation = false;
    },
  },
  methods: {
    nameErrorShow() {

      if(this.dataAddSubUser.name.length < 3){
        this.nameError = true
      } else this.nameError = false
    },
   async addSubUser() {
    this.dataAddSubUser.follow_up_phone.replaceAll(' ', '');
    try {
    const response = await Axios.post('second-clients/create', this.dataAddSubUser);
    this.notifySuccess("addToast", response.data.message);
    window.location.reload();
} catch (error) {
    if (error.response) {
      this.notifyFaild("faildAdd", error.response.data.error_msg);
    } 
  }    

    },
    submitData() {
      this.$validator.validateAll().then((result) => {
        const contryCodeSpan = document.querySelector('.vti__flag')
        this.dataAddSubUser.country_code = contryCodeSpan.classList[1]
        
        if (result) {
          if (this.type == 1) {
            this.addSubUser();
          } else if (this.type == 2) {
            this.editSubUser();
          }
        }
      });
    },
    clearErrorMessage(inputName) {
    inputName.replaceAll(' ', '').length != 13 ? this.validationsPhone.follow_up_phone = false : this.validationsPhone.follow_up_phone = true
  },
    async editSubUser(){
      try{
        const response = await Axios.patch('second-clients/update/'+this.id, this.dataAddSubUser);
        this.notifySuccess("addToast", response.data.message);
        window.location.reload();
      }catch (error) {
        if (error.response) {
          this.notifyFaild("faildAdd", error.response.data.error_msg);
        }

      }
    }
  },
  created() {
    if (this.type == 2) {
      this.dataAddSubUser = this.editData;
      this.validationsPhone.follow_up_phone = true
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/vuexy/_variables.scss";
@import "@/assets/scss/vuexy/_advancedSearch.scss";
.scroll-area--data-list-add-new {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 1rem - 2.8125rem - 5.125rem);
  &:not(.ps) {
    overflow-y: auto;
  }
}
label {
  font-size: 0.85rem;
  color: rgba(0, 0, 0, 0.7);
  padding-left: 5px;
  font-weight: bold;
}
.send-order {
  font-family: "Cairo", sans-serif;
  background-color: $mainColor1;
  color: #fff;
  width: 6rem;
  height: 2.625rem;
  border-radius: 0.25rem;
  border: none;
  font-size: 0.875rem;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  .loader {
    border: 2px solid #fff;
    border-top: 2px solid #ffffff4d;
  }
}
.cancel-btn {
  font-family: "Cairo", sans-serif;
  background-color: transparent;
  color: #ea5455;
  border: 0.0625rem solid #ea5455;
  padding: 6px 12px;
  border-radius: 0.25rem;
  font-size: 0.875rem;
  cursor: pointer;
  transition: 0.3s ease-in-out;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  .loader {
    border: 2px solid #ea5455;
    border-radius: 50%;
    border-top: 2px solid rgba(49, 0, 111, 0.1019607843);
    width: 15px;
    height: 15px;
    transition: 0.3s ease-in-out;
  }
  &:hover {
    background: #ea5455;
    color: #fff;
    .loader {
      border-color: #fff;
      border-top-color: rgba(49, 0, 111, 0.1019607843);
    }
  }
}
.opacity-btn1 {
  background-color: gray;
  cursor: default;
}
</style>